module.exports = __webpack_public_path__ + "static/media/companyIntroImg_2.a79898e6.png";